// @flow

import * as actionTypes from "./actionTypes";
import {
    apiClient,
    ApiRequest,
    AxiosRequest,
    apiBaseUrl,
    AppLogin,
    apiAdminUrl,
    WebDomain,
} from "./common";
import { openDialog } from "../base/dialog";
import AVSettingsDialog from "./components/device-selection/AVSettingsDialog";
import SettingsDialog from "./components/device-selection/SettingsDialog";
import { getFirebaseRefreshToken } from "./firebase/firebaseActions";
import { i18next } from "../base/i18n";
import swal from "sweetalert";
import * as ACTION from "./helpers/actions";
import AuthService from "./services/authService";

export function ShowLoader(value) {
    // loader with True False Values
    return (dispatch) => {
        dispatch({ type: actionTypes.SHOW_LOADER, payload: value });
    };
}

export const setRoomDetails = (data) => {
    return {
        type: actionTypes.SET_ROOM_DETAILS,
        data,
    };
};

export const setUserDetails = (payload) => {
    return {
        type: actionTypes.SET_USER_DETAIL,
        payload,
    };
};

/* For Auth */

export const getFirebaseUserOnlineStatus = (snapShotValue) => (dispatch) => {
    dispatch({
        type: actionTypes.USER_STATUS,
        payload: snapShotValue.val(),
    });
};

export const getFirebaseUserOfflineStatus = (snapShotValue) => (dispatch) => {
    dispatch({
        type: actionTypes.USER_OFFLINE_STATUS,
        payload: snapShotValue.val(),
    });
};

export const login = (formValues) => async (dispatch) => {
    const response = await apiClient("login", {
        method: "POST",
        body: formValues,
    });
    const { status } = response;
    if (status === 200) {
        localStorage.setItem("user_info", JSON.stringify(response.data));
        localStorage.setItem("token", response.token);
        dispatch(setUserDetails(response.data));
        await getFirebaseRefreshToken({ token: response.token });
        i18next.changeLanguage(response.data.lang);
        return status;
    }
};

export const signup = (formValues) => async (dispatch) => {
    const response = await apiClient("signup", {
        method: "POST",
        body: formValues,
    });
    return response;
};

/* For Meetings */
export function meetingList(list_type, last_id, page_no, row_per_page) {
    return async function (dispatch) {
        const type =
            list_type === "upcoming"
                ? actionTypes.UPCOMING_MEETING_LIST
                : actionTypes.PAST_MEETING_LIST;
        const response = await apiClient("meeting-listing", {
            method: "POST",
            body: { list_type, last_id, page_no, row_per_page },
        });
        const { status } = response;
        if (status === 200) {
            dispatch({
                type,
                payload: response,
            });
        }
    };
}

export function openAvSettingsDialog(defaultTab) {
    return openDialog(AVSettingsDialog, { defaultTab });
}

export function openSettingsDialog(defaultTab) {
    return openDialog(SettingsDialog, { defaultTab });
}

export const urlRouting = (url) => (dispatch) => {
    window.history.pushState(null, null, url);
    dispatch({
        type: actionTypes.CHANGE_URL,
        payload: url,
    });
    // return (dispatch) => {
    //     window.history.pushState(null, null, url);
    //     let abc = {
    //         type: actionTypes.CHANGE_URL,
    //         payload: url,
    //     }
    //     dispatch(abc);
    // };
};

export const validateMeeting = (ConferenceMeetId) => {
    return async (dispatch) => {
        if (localStorage.token) {
            ConferenceMeetId.token = localStorage.token;
        }
        const response = await apiClient("validate-meeting", {
            method: "POST",
            body: ConferenceMeetId,
        });
        // prettier-ignore
        const { status, data, access, TeamMember: teamMember, MeetingType } = response;
        if (typeof response.ResponseText !== "object") {
            sessionStorage.setItem("userRole", access);
            sessionStorage.setItem("teamMember", teamMember);
            sessionStorage.setItem("MeetingType", MeetingType);
            dispatch(
                meetingDetail({ RoomMeetId: ConferenceMeetId.RoomMeetId })
            );
            return response;
        } else {
            return status;
        }
    };
};

export const meetingDetail = (RoomMeetId) => async (dispatch) => {
    const response = await apiClient("meeting-details", {
        method: "POST",
        body: RoomMeetId,
    });
    const { status } = response;
    if (status === 200) {
        sessionStorage.setItem("meetDetails", JSON.stringify(response.data));
        dispatch({
            type: actionTypes.MEETING_DETAIL,
            payload: response.data,
        });
    }
};

export const recordingList = async () => {
    const response = await apiClient("post/recording-list", {
        method: "POST",
    });

    return response;
};

export const deleteRecording = async (id) => {
    const response = await apiClient("post/delete-recording", {
        method: "POST",
        body: id,
    });

    return response;
};

export const todaysMeetingList = async () => {
    const response = await apiClient("today-meeting-listing", {
        method: "POST",
    });
    return response;
};

/* For side navbar users */
export const sideNavBarMemberList = () => async (dispatch) => {
    return null;
};

/* For small chat windows */
export const setChatWindowsUser = (user) => async (dispatch) => {
    dispatch({
        type: actionTypes.CHAT_WINDOW_USERS,
        payload: user,
    });
};

export const removeChatWindowsUser = (userId) => async (dispatch) => {
    dispatch({
        type: actionTypes.REMOVE_CHAT_WINDOW_USER,
        payload: userId,
    });
};

/* For Meetings */
export function countriesList() {
    return async function (dispatch) {
        const response = await apiClient("country-list", {
            method: "GET",
        });
        const { status } = response;
        if (status === 200) {
            dispatch({
                type: actionTypes.GET_COUNTRIES_LIST,
                payload: response.data,
            });
        }
    };
}

export const NavigateToPage = (url) => (dispatch) => {
    window.history.pushState(url, null, url);
    let path = {
        type: actionTypes.CHANGE_URL,
        payload: url,
    };
    dispatch(path);
};

export const LoginFxn = async (body) => {
    let response = await ApiRequest({
        loader: true,
        method: "POST",
        body,
        path: "admin/login",
        alert: true,
        isLogin: true,
        loader_time: 1500,
        isAdminApiCall:true
    });
    return response;
};

export const MeetingCount = (data) => {
    return async (dispatch) => {
        const response = await ApiRequest({
            method: "POST",
            path: "userPanel/meeting-counts",
            token: true,
            loader: true,
            reducer: "MEETING_COUNTS",
            loader_time: 1500,
        });
        if (response.ResponseCode && response.ResponseCode === "1") {
            return 1;
        } else {
            swal({
                title: "Error!",
                text: response.ResponseText,
                icon: "error",
            });
            return 0;
        }
    };
};

export const TotalMeetings = (data) => {
    return async (dispatch) => {
        const response = await ApiRequest({
            method: "POST",
            path: "userPanel/total-meetings",
            token: true,
            loader: true,
            reducer: "TOTAL_MEETINGS",
            loader_time: 1500,
        });
        if (response.ResponseCode && response.ResponseCode === "1") {
            return 1;
        } else {
            swal({
                title: "Error!",
                text: response.ResponseText,
                icon: "error",
            });
            return 0;
        }
    };
};

export const FollowerWeeklyDetail = () => {
    return async (dispatch) => {
        const response = await ApiRequest({
            method: "POST",
            path: `${ACTION.USERPANEL}${ACTION.WEEKLY_DETAILS}`,
            token: true,
            body: { type: "web" },
            loader: true,
            reducer: "FOLLOWER_WEEKLY_DETAILS",
            loader_time: 1500,
        });
        if (response.ResponseCode && response.ResponseCode === "1") {
            return 1;
        } else {
            swal({
                title: "Error!",
                text: response.ResponseText,
                icon: "error",
            });
            return 0;
        }
    };
};

export const FetchUserDetails = () => {
    return async (dispatch) => {
        const response = await ApiRequest({
            method: "GET",
            path: "userPanel/user-detail",
            token: true,
            loader: true,
            reducer: "FETCH_USER_DETAILS",
            loader_time: 1500,
        });
        if (response.ResponseCode && response.ResponseCode === "1") {
            return 1;
        } else {
            swal({
                title: "Error!",
                text: response.ResponseText,
                icon: "error",
            });
            return 0;
        }
    };
};

export const UpdateUserDetails = (body) => {
    body = { ...body, action: "rica" };
    return async (dispatch) => {
        const response = await ApiRequest({
            method: "POST",
            path: "userPanel/user-update",
            token: true,
            loader: true,
            loader_time: 1500,
            body,
        });
        if (response.ResponseCode && response.ResponseCode === "1") {
            dispatch(FetchUserDetails());
            return { code: 1, data: response.data };
        } else {
            swal({
                title: "Error!",
                text: response.ResponseText,
                icon: "error",
            });
            return { code: 0 };
        }
    };
};

export const UpdateAddressDetails = (body) => {
    body = { ...body, action: "rica" };
    return async (dispatch) => {
        const response = await ApiRequest({
            method: "POST",
            path: "userPanel/rica-address",
            token: true,
            loader: true,
            loader_time: 1500,
            body,
        });
        if (response.ResponseCode && response.ResponseCode === "1") {
            dispatch(FetchUserDetails());
            return 1;
        } else {
            swal({
                title: "Error!",
                text: response.ResponseText,
                icon: "error",
            });
            return 0;
        }
    };
};

export const UpdateProfileDetails = (body) => {
    return async (dispatch) => {
        const response = await ApiRequest({
            method: "POST",
            path: "userPanel/user-update",
            token: true,
            loader: true,
            loader_time: 1500,
            body,
        });
        if (response.ResponseCode && response.ResponseCode === "1") {
            dispatch(FetchUserDetails());
            swal({
                title: "Success!",
                text: response.ResponseText,
                icon: "success",
            });
            return 1;
        } else {
            swal({
                title: "Error!",
                text: response.ResponseText,
                icon: "error",
            });
            return 0;
        }
    };
};

export const ExtensionListing = (id) => {
    return async (dispatch) => {
        const response = await ApiRequest({
            method: "POST",
            path: `extension-list`,
            token: true,
            loader: true,
            loader_time: 1500,
            body: { id },
            // reducer: "FETCH_EXTENSION_LISTING",
        });
        if (response.ResponseCode && response.ResponseCode === "1") {
            return { code: 1, data: response.data };
        } else {
            swal({
                title: "Error!",
                text: response.ResponseText,
                icon: "error",
            });
            return 0;
        }
    };
};

export const FollowerListing = () => {
    return async (dispatch) => {
        const response = await ApiRequest({
            method: "POST",
            path: `userPanel/follower-listing`,
            token: true,
            loader: true,
            loader_time: 1500,
            // reducer: "FTECH_FOLLOWERS_LISTING",
        });
        if (response.ResponseCode && response.ResponseCode === "1") {
            return { code: 1, data: response.data };
        } else {
            return 0;
        }
    };
};

export const ExtensionFollowerListing = async () => {
    const response = await ApiRequest({
        method: "POST",
        path: `extension-follower`,
        token: true,
        loader: true,
        loader_time: 1500,
    });
    if (response.ResponseCode && response.ResponseCode === "1") {
        return { code: 1, ResponseData: response };
    } else {
        return 0;
    }
};

export function SelectedChatUser(data) {
    return (dispatch) => {
        dispatch({ type: actionTypes.SELECTED_CHAT_USER, payload: data });
    };
}

export function SelectedGroupChatUser(data) {
    return (dispatch) => {
        dispatch({ type: actionTypes.SELECTED_GROUP_CHAT_USER, payload: data });
    };
}

export function FetchGroupUniqueKey(data) {
    return (dispatch) => {
        dispatch({ type: actionTypes.FETCH_GROUP_UNIQUEKEY, payload: data });
    };
}

export function SelectedChatType(data) {
    return (dispatch) => {
        dispatch({ type: actionTypes.SELECTED_CHAT_TYPE, payload: data });
    };
}

export function CreateGroupMember(data) {
    return (dispatch) => {
        dispatch({ type: actionTypes.CREATE_GROUP_MEMBER, payload: data });
    };
}

export function NavigateToPlanner(data) {
    return (dispatch) => {
        dispatch({ type: actionTypes.NAVIGATE_TO_PLANNER, payload: data });
    };
}

export const openMainPageSection = (data) => {
    return (dispatch) => {
        dispatch({ type: actionTypes.OPEN_MAIN_PAGE_SECTION, payload: data });
    };
};

export const navigateToPhoneSystem = (data) => {
    return (dispatch) => {
        dispatch({ type: actionTypes.NAVIGATE_TO_PHONESYSTEM, payload: data });
    };
};

export const NavigatetoScheduleMeeting = (data) => {
    return (dispatch) => {
        dispatch({
            type: actionTypes.NAVIGATE_TO_SCHEDULE_MEETING,
            payload: data,
        });
    };
};

export const NavigatetoPowerApps = (data) => {
    return (dispatch) => {
        dispatch({ type: actionTypes.NAVIGATE_TO_POWER_APPS, payload: data });
    };
};

export const navigateToBuy = (data) => {
    return (dispatch) => {
        dispatch({ type: actionTypes.NAVIGATE_TO_BUY, payload: data });
    };
};

export const navigateToCallInfo = (data) => {
    return (dispatch) => {
        dispatch({ type: actionTypes.NAVIGATE_TO_CALL_INFO, payload: data });
    };
};

export const navigateToNotes = (data) => {
    return (dispatch) => {
        dispatch({ type: actionTypes.NAVIGATE_TO_NOTES, payload: data });
    };
};

export const TotalAmount = (data) => {
    return (dispatch) => {
        dispatch({ type: actionTypes.FETCH_TOTAL_AMOUNT, payload: data });
    };
};

export const navigateToOrderItems = (data) => {
    return (dispatch) => {
        dispatch({ type: actionTypes.NAVIGATE_TO_ORDER_ITEMS, payload: data });
    };
};

export const OpenChatInfoPage = (data) => {
    return (dispatch) => {
        dispatch({ type: actionTypes.OPEN_CHAT_INFO_PAGE, payload: data });
    };
};

export const naviagteToSetting = (data) => {
    return (dispatch) => {
        dispatch({ type: actionTypes.NAVIGATE_TO_SETTING, payload: data });
    };
};

export const GetDaysAndDates = () => {
    return async (dispatch) => {
        const response = await ApiRequest({
            method: "POST",
            path: `get-dates-and-days`,
            loader: true,
            loader_time: 1500,
            reducer: "FTECH_DAYS_AND_DATES",
        });
        if (response.ResponseCode && response.ResponseCode === "1") {
            return 1;
        } else {
            return 0;
        }
    };
};

export const MeetingListing = (body) => {
    return async (dispatch) => {
        const response = await ApiRequest({
            method: "POST",
            path: `userPanel/meeting-listing`,
            token: true,
            loader: true,
            loader_time: 1500,
            reducer: "FTECH_MEETING_LISTING",
            body,
        });
        if (response.ResponseCode && response.ResponseCode === "1") {
            return 1;
        } else {
            return 0;
        }
    };
};

// CALL ACTIONS

export const RecentCallListing = () => {
    return async (dispatch) => {
        const response = await ApiRequest({
            method: "POST",
            path: `userPanel/call-history`,
            token: true,
            loader: true,
            loader_time: 1500,
            reducer: "FETCH_RECENT_CALL_LISTING",
        });
        if (response.ResponseCode && response.ResponseCode === "1") {
            return 1;
        } else {
            return 0;
        }
    };
};

// export const PhoneSystemList = () => {
//     return async (dispatch) => {
//         const response = await ApiRequest({
//             method: "GET",
//             path: `userPanel/team`,
//             token: true,
//             loader: true,
//             loader_time: 1500,
//             reducer: "PHONESYSTEM_TEAM",
//         });
//         if (response.ResponseCode && response.ResponseCode === "1") {
//             return 1;
//         } else {
//             return 0;
//         }
//     };
// };

/********************Meeting*****************************/

export const QuickMeeting = (body) => {
    return async (dispatch) => {
        const response = await ApiRequest({
            method: "POST",
            path: `userPanel/quick-meeting`,
            token: true,
            loader: true,
            loader_time: 1500,
            body,
        });
        if (response.ResponseCode && response.ResponseCode === "1") {
            return response;
        } else {
            return 0;
        }
    };
};

export const JoinMeeting = (body) => {
    return async (dispatch) => {
        const response = await ApiRequest({
            method: "POST",
            path: `/authorize-meeting`,
            loader: true,
            loader_time: 1500,
            body,
        });
        if (response.ResponseCode && response.ResponseCode === "1") {
            return 1;
        } else {
            swal({
                title: "Error!",
                text: response.ResponseText,
                icon: "error",
            });
            return 0;
        }
    };
};
const handleResponse = (response) => {
    return response.text().then((text) => {
        const data = text && JSON.parse(text);
        if (!response.ok) {
            if (response.status === 401 || response.status === 400) {
                swal({
                    title: "Expired!",
                    text: "Your session is expired!",
                    icon: "error" 
                }) 
                localStorage.removeItem("token");
                window.location.href =`https://${WebDomain}`;
            }
            const error = (data && data.message) || response.statusText;
            return Promise.reject(error);
        }
        return data;
    });
};

export const UserSignUp = async (params) => {
    APP.store.dispatch({ type: actionTypes.SHOW_LOADER, payload: true });
    const request = new Request(`${apiBaseUrl}/user/signup`, {
        method: "POST",
        body: JSON.stringify(params),
        headers: new Headers({ "Content-Type": "application/json" }),
    });
    const result = await fetch(request);
    const data = await result.json();
    if (data.ResponseCode === "1") {
        if (params.token && params.token === true && data.token) {
            location.href = `${AppLogin}${data.token}`;
        } else {
            APP.store.dispatch({
                type: actionTypes.SHOW_LOADER,
                payload: false,
            });
            localStorage.setItem("token", data.token);
            localStorage.setItem("data", JSON.stringify(data.data));
        }
        return 1;
    } else {
        APP.store.dispatch({ type: actionTypes.SHOW_LOADER, payload: false });
        swal({
            title: "Error!",
            text: data.ResponseText,
            icon: "error",
        });
        return 0;
    }
};

export const ZohoCreateLead = (params) => {
    APP.store.dispatch({ type: actionTypes.SHOW_LOADER, payload: true });
    const request = new Request(ACTION.ZOHO_CREATE_LEAD, {
        method: "POST",
        body: JSON.stringify(params),
        headers: new Headers({ "Content-Type": "application/json" }),
    });
    return fetch(request)
        .then((res) => res.json())
        .then((response) => {
            if (response?.Data?.success) {
                return response?.Data?.resultData?.[0]?.details?.id;
            } else {
                swal({
                    title: "Error!",
                    text: response?.Data?.resultData?.[0]?.message,
                    icon: "error",
                });
                APP.store.dispatch({
                    type: actionTypes.SHOW_LOADER,
                    payload: false,
                });
                return null;
            }
        })
        .catch((error) => {
            console.error(error);
            APP.store.dispatch({
                type: actionTypes.SHOW_LOADER,
                payload: false,
            });
            return null;
        });
};

export const ZohoConvertLead = (params) => {
    APP.store.dispatch({ type: actionTypes.SHOW_LOADER, payload: true });
    const request = new Request(ACTION.ZOHO_CONVERT_LEAD, {
        method: "POST",
        body: JSON.stringify(params),
        headers: new Headers({ "Content-Type": "application/json" }),
    });
    return fetch(request)
        .then((res) => res.json())
        .then((response) => {
            if (
                response?.Data?.success &&
                response?.Data?.resultData?.[0]?.Contacts !== "" &&
                response?.Data?.resultData?.[0]?.Accounts
            ) {
                return {
                    zoho_account: response.Data.resultData[0].Accounts,
                    zoho_contact: response.Data.resultData[0].Contacts,
                };
            } else {
                swal({
                    title: "Error!",
                    text: response?.Data?.resultData?.[0]?.message,
                    icon: "error",
                });
                return null;
            }
        })
        .catch((error) => {
            console.error(error);
            return null;
        });
};

export const ZohoSaveLeadsLocal = (params) => {
    const token = AuthService.getUserAccessToken();
    const request = new Request(`${apiBaseUrl}userPanel/create-zoho-client`, {
        method: "POST",
        body: JSON.stringify(params),
        headers: new Headers({
            "Content-Type": "application/json",
            "X-Auth-Token": token,
        }),
    });
    return fetch(request)
        .then(handleResponse)
        .then((data) => {
            if (data.ResponseCode === "1") {
                APP.store.dispatch({
                    type: actionTypes.SHOW_LOADER,
                    payload: false,
                });
                return 1;
            } else {
                APP.store.dispatch({
                    type: actionTypes.SHOW_LOADER,
                    payload: false,
                });
                return 0;
            }
        });
};

export const ZohoCreateSubscription = (params) => {
    APP.store.dispatch({ type: actionTypes.SHOW_LOADER, payload: true });
    const request = new Request(ACTION.ZOHO_CREATE_SUBSCRIPTION, {
        method: "POST",
        body: JSON.stringify(params),
        headers: new Headers({ "Content-Type": "application/json" }),
    });
    return fetch(request)
        .then((res) => res.json())
        .then((response) => {
            APP.store.dispatch({
                type: actionTypes.SHOW_LOADER,
                payload: false,
            });
            if (
                response?.Data?.success &&
                response?.Data?.subscription?.subscription_id
            ) {
                return response?.Data?.subscription?.subscription_id;
            } else {
                swal({
                    title: "Error!",
                    text: response?.Data?.resultData?.[0]?.message,
                    icon: "error",
                });
                return null;
            }
        })
        .catch((error) => {
            APP.store.dispatch({
                type: actionTypes.SHOW_LOADER,
                payload: false,
            });
            console.error(error);
            return null;
        });
};

export const ZohoUpdateSubscription = (params) => {
    APP.store.dispatch({ type: actionTypes.SHOW_LOADER, payload: true });
    const request = new Request(ACTION.ZOHO_UPDATE_SUBSCRIPTION, {
        method: "POST",
        body: JSON.stringify(params),
        headers: new Headers({ "Content-Type": "application/json" }),
    });
    return fetch(request)
        .then((res) => res.json())
        .then((response) => {
            APP.store.dispatch({
                type: actionTypes.SHOW_LOADER,
                payload: false,
            });
            if (response?.Data?.success) {
                return response?.Data?.subscription?.subscription_id;
            } else {
                swal({
                    title: "Error!",
                    text: response?.Data?.message,
                    icon: "error",
                });
                return null;
            }
        })
        .catch((error) => {
            APP.store.dispatch({
                type: actionTypes.SHOW_LOADER,
                payload: false,
            });
            console.error(error);
            return null;
        });
};

export const DeviceProductCart = (data) => {
    return (dispatch) => {
        dispatch({
            type: actionTypes.FETCH_DEVICE_PRODUCT_CART,
            payload: data,
        });
    };
};

export const HomePageSubPages = (data) => {
    return (dispatch) => {
        dispatch({ type: actionTypes.SUB_PAGES, payload: data });
    };
};

export const HomePageSubTabs = (data) => {
    return (dispatch) => {
        dispatch({ type: actionTypes.SUB_TABS, payload: data });
    };
};

export const mapAddress = (data) => {
    return (dispatch) => {
        dispatch({ type: actionTypes.GOOGLE_MAP_ADDRESS, payload: data });
    };
};

export const DashboardDetails = (params) => {
    const token = AuthService.getUserAccessToken();
    return (dispatch) => {
        dispatch({ type: actionTypes.SHOW_LOADER, payload: true });
        const request = new Request(
            `${apiBaseUrl}/userPanel/call-history-info`,
            {
                method: "POST",
                body: JSON.stringify(params),
                headers: new Headers({
                    "Content-Type": "application/json",
                    "X-Auth-Token": token,
                }),
            }
        );
        return fetch(request)
            .then(handleResponse)
            .then((data) => {
                dispatch({ type: actionTypes.SHOW_LOADER, payload: false });
                if (data.ResponseCode === "1") {
                    dispatch({
                        type: actionTypes.FETCH_ALL_DESTINATION_LISTING,
                        payload: data.data,
                    });
                }
                return 1;
            })
            .catch((error) => {
                dispatch({ type: actionTypes.SHOW_LOADER, payload: false });
            });
    };
};

export const FetchForgotPassword = (params) => {
    return (dispatch) => {
        dispatch({ type: actionTypes.SHOW_LOADER, payload: true });
        const request = new Request(`${apiBaseUrl}/forgot-password`, {
            method: "POST",
            body: JSON.stringify(params),
            headers: new Headers({
                "Content-Type": "application/json",
            }),
        });
        return fetch(request)
            .then(handleResponse)
            .then((data) => {
                dispatch({ type: actionTypes.SHOW_LOADER, payload: false });
                if (data.ResponseCode === "1") {
                    swal({
                        title: "Success!",
                        text: data.ResponseText,
                        icon: "success",
                    });
                    return 1;
                } else {
                    swal({
                        title: "Error!",
                        text: data.ResponseText,
                        icon: "error",
                    });
                    return 0;
                }
            })
            .catch((error) => {
                dispatch({ type: actionTypes.SHOW_LOADER, payload: false });
            });
    };
};

export const FetchForgotEmail = (params) => {
    return (dispatch) => {
        dispatch({ type: actionTypes.SHOW_LOADER, payload: true });
        const request = new Request(`${apiBaseUrl}/api-recover-email`, {
            method: "POST",
            body: JSON.stringify(params),
            headers: new Headers({
                "Content-Type": "application/json",
            }),
        });
        return fetch(request)
            .then(handleResponse)
            .then((data) => {
                dispatch({ type: actionTypes.SHOW_LOADER, payload: false });
                if (data.ResponseCode === "1") {
                    return { code: 1, data: data?.data };
                } else {
                    swal({
                        title: "Error!",
                        text: data.ResponseText,
                        icon: "error",
                    });
                    return { code: 0 };
                }
            })
            .catch((error) => {
                dispatch({ type: actionTypes.SHOW_LOADER, payload: false });
            });
    };
};

export const FetchResetPassword = (params) => {
    return (dispatch) => {
        dispatch({ type: actionTypes.SHOW_LOADER, payload: true });
        const request = new Request(`${apiBaseUrl}/reset-password`, {
            method: "POST",
            body: JSON.stringify(params),
            headers: new Headers({
                "Content-Type": "application/json",
            }),
        });
        return fetch(request)
            .then(handleResponse)
            .then((data) => {
                dispatch({ type: actionTypes.SHOW_LOADER, payload: false });
                if (data.ResponseCode === "1") {
                    swal({
                        title: "Success!",
                        text: data.ResponseText,
                        icon: "success",
                    });
                    return 1;
                } else {
                    swal({
                        title: "Error!",
                        text: data.ResponseText,
                        icon: "error",
                    });
                    return 0;
                }
            })
            .catch((error) => {
                dispatch({ type: actionTypes.SHOW_LOADER, payload: false });
            });
    };
};

export const VerifyForgotPassword = (params) => {
    return (dispatch) => {
        dispatch({ type: actionTypes.SHOW_LOADER, payload: true });
        const request = new Request(`${apiBaseUrl}verify-password-otp`, {
            method: "POST",
            body: JSON.stringify(params),
            headers: new Headers({
                "Content-Type": "application/json",
            }),
        });
        return fetch(request)
            .then(handleResponse)
            .then((data) => {
                dispatch({ type: actionTypes.SHOW_LOADER, payload: false });
                if (data.ResponseCode === "1") {
                    if (params.password) {
                        localStorage.setItem("token", data.token);
                        localStorage.setItem("data", JSON.stringify(data.data));
                    }
                    swal({
                        title: "Success!",
                        text: data.ResponseText,
                        icon: "success",
                    });
                    return 1;
                } else {
                    swal({
                        title: "Error!",
                        text: data.ResponseText,
                        icon: "error",
                    });
                    return 0;
                }
            })
            .catch((error) => {
                dispatch({ type: actionTypes.SHOW_LOADER, payload: false });
            });
    };
};

export const LobbyVisible = (response) => {
    return (dispatch) => {
        dispatch({
            type: actionTypes.IS_VISIBLE_LOBBY,
            payload: response,
        });
    };
};

export const LobbyKnockers = (response) => {
    return (dispatch) => {
        dispatch({
            type: actionTypes.KNOCKING_LIST_LOBBY,
            payload: response,
        });
    };
};

export const AddressVerified = (data) => {
    return (dispatch) => {
        dispatch({
            type: actionTypes.ADDRESS_VERIFIED,
            payload: data,
        });
    };
};

export const SelectedPlanDuringSignup = (data) => {
    return (dispatch) => {
        dispatch({
            type: actionTypes.SELECTED_PLAN_DURING_SIGNUP,
            payload: data,
        });
    };
};

export const isNxaDemoBooking = (data) => {
    return (dispatch) => {
        dispatch({ type: actionTypes.IS_NXA_DEMO_BOOKING, payload: data });
    };
};

export const FetchEmailFromToken = (params) => {
    return (dispatch) => {
        dispatch({ type: actionTypes.SHOW_LOADER, payload: true });
        const request = new Request(`${apiAdminUrl}fetch-email-fromToken `, {
            method: "POST",
            body: JSON.stringify(params),
            headers: new Headers({
                "Content-Type": "application/json",
            }),
        });
        return fetch(request)
            .then(handleResponse)
            .then((data) => {
                dispatch({ type: actionTypes.SHOW_LOADER, payload: false });
                if (data.ResponseCode === "1") {
                    return { code: 1, email: data?.email };
                } else {
                    swal({
                        title: "Error!",
                        text: data.ResponseText,
                        icon: "error",
                    });
                    return { code: 0 };
                }
            })
            .catch((error) => {
                dispatch({ type: actionTypes.SHOW_LOADER, payload: false });
            });
    };
};

export const VerifyExtension = (params) => {
    return (dispatch) => {
        dispatch({ type: actionTypes.SHOW_LOADER, payload: true });
        const request = new Request(`${apiAdminUrl}verify-extension `, {
            method: "POST",
            body: JSON.stringify(params),
            headers: new Headers({
                "Content-Type": "application/json",
            }),
        });
        return fetch(request)
            .then(handleResponse)
            .then((data) => {
                dispatch({ type: actionTypes.SHOW_LOADER, payload: false });
                if (data.ResponseCode === "1") {
                    return 1;
                } else {
                    swal({
                        title: "Error!",
                        text: data.ResponseText,
                        icon: "error",
                    });
                    return 0;
                }
            })
            .catch((error) => {
                dispatch({ type: actionTypes.SHOW_LOADER, payload: false });
            });
    };
};

export const getFullScreenUserId = (data) => {
    return (dispatch) => {
        dispatch({ type: actionTypes.GET_FULL_SCREEN_USERID, payload: data });
    };
};

export const activeGuestShareScreen = (data) => {
    return (dispatch) => {
        dispatch({
            type: actionTypes.ACTIVATE_GUEST_SHARE_SCREEN,
            payload: data,
        });
    };
};

export const isRecordingOn = (data) => {
    return (dispatch) => {
        dispatch({ type: actionTypes.IS_RECORDING_ON, payload: data });
    };
};

export const additionalModerator = (data) => {
    return (dispatch) => {
        dispatch({ type: actionTypes.ADDITIONAL_MODERATOR, payload: data });
    };
};

export const LoginWithTokenFxn = (params) => {
    return (dispatch) => {
        dispatch({ type: actionTypes.SHOW_LOADER, payload: true });
        const request = new Request(`${apiAdminUrl}meetLogin-by-token `, {
            method: "POST",
            body: JSON.stringify(params),
            headers: new Headers({
                "Content-Type": "application/json",
            }),
        });
        return fetch(request)
            .then(handleResponse)
            .then((data) => {
                dispatch({ type: actionTypes.SHOW_LOADER, payload: false });
                if (data) {
                    let properties = {
                        name: data?.data?.firstname,
                        fullname: `${data?.data?.firstname} ${data?.data?.lastname}`,
                    };
                    localStorage.setItem("token", data?.token);
                    localStorage.setItem("type", data?.data?.type);
                    localStorage.setItem("customerID", data?.data?.customerID);
                    localStorage.setItem(
                        "properties",
                        JSON.stringify(properties)
                    );
                    localStorage.setItem("data", JSON.stringify(data?.data));
                    return data;
                } 
            })
            .catch((error) => {
                dispatch({ type: actionTypes.SHOW_LOADER, payload: false });
            });
    };
};
